import { init } from "../init-streaming";
import { SignupPage } from "../pages/try/cloud/signup/signup-page";
init(SignupPage);
